/**
 * The marks drawn on top of the plot on hover — the crosshairs, the dots that
 * terminate them at the axes, and the series' own point markers — and the
 * order they stack in.
 *
 * They live together because every one of these values only means something
 * relative to the others. Highcharts' own layers set the floor: the series
 * group sits at 3 and the axis labels at 7, so anything meant to read over a
 * filled band has to clear 3, and anything inside the plot area can safely
 * pass 7 because the labels sit outside it.
 *
 *   3  series fills
 *   5  crosshairs        — over the fills, or a stacked area chart swallows them
 *   6  crosshair dots    — over the line each one terminates
 *   7  point markers     — over the crosshair, so the line never cuts a dot
 */

/** Reads as a mid-grey on both the light and the dark surface. */
export const CROSSHAIR_COLOR = "#88888A"

export const CROSSHAIR_Z_INDEX = 5
export const CROSSHAIR_DOT_Z_INDEX = 6

/**
 * Point markers, raised out of the series group onto the chart root.
 *
 * Highcharts parents each series' marker group to the shared series group, so
 * no z-index set on it can beat a root-level sibling — the crosshair would be
 * painted over every hover dot. Re-parenting to the root is what makes the
 * comparison possible at all; see the chart's `render` handler.
 */
export const MARKER_GROUP_Z_INDEX = 7
